<template>
    <div class="meeting-container">
        <div :class="[{insideopen: insideshow},'meeting-main']">
            <div class="meeting-header clearfix">
                <div class="meeting-class-title">
                    <div class="meeting-videocontral">
                        <div :class="[{on:isaudioopen},'audioswitch item']" @click="closeAudioMedtiator(userID,1)">{{isaudioopen ? '关闭语音' : '开启语音'}}</div>
                        <div :class="[{on:isvideoopen},'videoswitch item']" @click="closeVideoMedtiator(userID,1)">{{isvideoopen ? '关闭视频' : '开启视频'}}</div>
                        <div class="inviteswitch item" @click="invitemeeting">邀请</div>
                        <div class="invitesCode item" @click="inviteCodeSearch">邀请码查阅</div>
                        <div class="invitesbobao item" @click="handleBobaodialog">播报</div>
                        <a href="/abilitytest/index.html" style="color:#fff;" target="_blank" class="check item">音视频检测</a>
                        <div class="center">
                            <!-- <div class="inviteswitch item" @click="invitemeeting">邀请协助</div> -->
                            <!-- <div :class="[{on:isFaceOpen},'faceswitch item']" @click="countenanceSwitch">情绪识别
                            <el-tooltip class="item" effect="light" placement="right-start">
                                <div slot="content">系统将通过面部表情识别出平静、高兴、<br/>愤怒、恐惧、悲伤、厌恶、惊奇7种情绪，<br/>调解过程中若当事人情绪过于愤怒或悲伤<br/>时会发出预警，以协助您更好的调解纠纷。</div>
                                <i class="face_switch_tooltip"></i>
                            </el-tooltip>
                        </div> -->
                        <!-- <div class="chatswitch item" @click="openSelfChat">文字私聊</div> -->
                            <!-- <div :class="[{designatedSpeech:speechMode === 'SPECIFY'},'freeSpeech item']" @click="changeSpeechMode">{{speechMode === 'SPECIFY' ? '自由发言' : '指定发言'}}</div> -->
                            <!-- <div class="closemeeting" @click="closeMeeting">结束视频</div> -->
                            <div :class="[{on:videotape},'recordswitch item']" @click="recordAudio">{{videotape?'停止':'开始'}}录制</div>
                        </div>
                    </div>
                    <div class="meetingexit"><div class="quit" @click="leaveRoom"><i class="ico_quit"></i>结束视频</div></div>
                </div>
            </div>
            <div class="meeting-area-main">
                <div class="curmemberinfo">
                    <span class="memberinfo">
                        {{mainView.role == 'MEDIATOR'?mainView.rolename:(mainView.rolename+'：'+mainView.name)}}
                        <i class="audio" v-if="!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].audio)"></i>
                        <i class="hand" v-if="handMap[mainView.id]"></i>
                    </span>
                    <i class="timing">{{mytime}}</i>
                    <el-dropdown class="more">
                        <span class="el-dropdown-link">
                            <i class="more-icon"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><div @click="closeAudioMedtiator(mainView.id,1)">{{(requestingPushers[mainView.id] && requestingPushers[mainView.id].audio) ? '关闭语音' : '开启语音'}}</div></el-dropdown-item>
                            <el-dropdown-item><div @click="closeVideoMedtiator(mainView.id,1)">{{(requestingPushers[mainView.id] && requestingPushers[mainView.id].video) ? '关闭视频' : '开启视频'}}</div></el-dropdown-item>
                            <!-- <el-dropdown-item v-if="mainView.id !=userID"><div @click="videoChat(mainView.id)">视频私聊</div></el-dropdown-item> -->
                            <!-- <el-dropdown-item>
                                <div @click="throwScreen(mainView.id,mainView.name,mainView)">投屏</div>
                            </el-dropdown-item> -->
                            <el-dropdown-item v-if="mainView.id !=userID"><div @click="chatSwitch(mainView.id,mainView.name,mainView.rolename,mainView.role)" :class="[{isnew:messageActive[mainView.id] && messageActive[mainView.id].isnew}]">文字私聊</div></el-dropdown-item>
                            <el-dropdown-item v-if="selectedMainViewId"><div @click="cancelMainScreen()">取消主视频</div></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-show="(onlineStatus[mainView.id]=='ONLINE')&&Boolean(requestingPushers[mainView.id])&&!Boolean(requestingPushers[mainView.id] && requestingPushers[mainView.id].video)" class="exitroom">{{mainView.role == 'MEDIATOR'?mainView.rolename:mainView.name}} 关闭了视频</div>
                <div v-show="onlineStatus[mainView.id]=='OFFLINE'" class="exitroom">{{mainView.role == 'MEDIATOR'?mainView.rolename:mainView.name}} 离开了视频会议</div>
                <div v-if="!Boolean(onlineStatus[mainView.id])" class="exitroom">等待进入视频会议</div>
                <video id="localVideo" :class="[{on:handMap[mainView.id]},'mainvideo']" autoplay playinline></video>
                <!-- <div v-if="emotional[mainView.id] && (mainView.id != mediatorInfo.id) && onlineStatus[mainView.id]!='OFFLINE'" v-show="faceSwitchStatus" class="countenance">
                    <el-popover  placement="top" popper-class="meeting_face" trigger="hover">
                        <div class="currnet_face_info">
                            <p>人脸表情识别占比（%）</p>
                            
                            <ul>
                                <li class="face_li_a"><span>平静：{{emotional[mainView.id].neutral}}%</span></li>
                                <li class="face_li_b"><span>高兴：{{emotional[mainView.id].happiness}}%</span></li>
                                <li class="face_li_c"><span :class="{active:Math.floor(emotional[mainView.id].anger)>=emotional[mainView.id].twinkle}">愤怒：{{emotional[mainView.id].anger}}%</span></li>
                                <li class="face_li_d"><span>恐惧：{{emotional[mainView.id].fear}}%</span></li>
                                <li class="face_li_e"><span :class="{active:Math.floor(emotional[mainView.id].sadness)>=emotional[mainView.id].twinkle}">悲伤：{{emotional[mainView.id].sadness}}%</span></li>
                                <li class="face_li_f"><span>厌恶：{{emotional[mainView.id].disgust}}%</span></li>
                                <li class="face_li_g"><span>惊奇：{{emotional[mainView.id].surprise}}%</span></li>
                            </ul>
                        </div>
                        <div slot="reference" class="face_boxtop"><i :class="[{on:Math.floor(emotional[mainView.id].anger)>=emotional[mainView.id].twinkle||Math.floor(emotional[mainView.id].sadness)>=emotional[mainView.id].twinkle},emotional[mainView.id].maxEmotional]"></i></div>
                    </el-popover>
                </div> -->
            </div>
            <div class="member-list-container">
                <div class="right_scroll" @click="memberListScroll(false)"></div>
                <div ref="meetingMemberList" class="meeting-member-list-inner">
                    <ul class="meeting-scroll" v-bind:style="'width:'+members.length*250+'px'" >
                        <li v-for="(item, index) in members" :key="index" class="meeting-member-box">
                            <template  v-if="(item.id != mainView.id) && item.id">
                                <div class="meeting-member-body" :data='item.id'>
                                    <div class="meeting-member-body-info">
                                        <div>
                                            <i :class="[{on:requestingPushers[item.id] && requestingPushers[item.id].audio},'icon_useraudio']"></i>
                                            <!-- <i v-if="item.id!=userID" @click="chatSwitch(item.id,item.name,item.rolename,item.role)" :class="[{on:messageActive[item.id] && messageActive[item.id].isnew},'icon_chatmessage']"></i> -->
                                            <!-- <i class="icon_hand" v-if="handMap[item.id]"></i> -->
                                            <el-dropdown class="more">
                                                <span class="el-dropdown-link">
                                                    <i class="more-icon"></i>
                                                </span>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item><div @click="closeAudioMedtiator(item.id,1)">{{(requestingPushers[item.id] && requestingPushers[item.id].audio) ? '关闭语音' : '开启语音'}}</div></el-dropdown-item>
                                                    <el-dropdown-item><div @click="closeVideoMedtiator(item.id,1)">{{(requestingPushers[item.id] && requestingPushers[item.id].video) ? '关闭视频' : '开启视频'}}</div></el-dropdown-item>
                                                    <el-dropdown-item :disabled="item.id===userID"><div @click="chatSwitch(item.id,item.name,item.rolename,item.role)" :class="[{isnew:messageActive[item.id] && messageActive[item.id].isnew}]">文字私聊</div></el-dropdown-item>
                                                    <el-dropdown-item><div @click="setMainScreen(item.id)">设为主视频</div></el-dropdown-item>
                                                    <el-dropdown-item :disabled="item.id===userID"><div @click="hiddenUserScreen(item.id, requestingPushers[item.id].shield)">{{(requestingPushers[item.id] && requestingPushers[item.id].shield) ? '取消屏蔽' : '屏蔽'}}</div></el-dropdown-item>
                                                    <!-- <el-dropdown-item v-if="item.id!=userID"><div @click="videoChat(item.id)">视频私聊</div></el-dropdown-item> -->
                                                    <!-- <el-dropdown-item><div @click="throwScreen(item.id,item.name,item)">投屏</div></el-dropdown-item> -->
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                            <el-button @click="closeAudioMedtiator(item.id,1)" class="video-btn" size="mini">{{(requestingPushers[item.id] && requestingPushers[item.id].audio) ? '关闭语音' : '开启语音'}}</el-button>
                                        </div>
                                    </div>
                                </div>
                                <!-- 互动人员图片 start -->
                                <div class="meeting-member-img" :id="'video_'+(item.id)">
                                    <div v-if="pusherVideosDisplay[item.id]" class="exitroom">{{item.name}} {{item.id!=privateUserId?'断开了视频连接':'正在私聊中'}}</div>
                                    <!-- <div v-if="emotional[item.id] && (item.id != mediatorInfo.id)" v-show="faceSwitchStatus" class="countenance">
                                        <el-popover  placement="top" popper-class="meeting_face" trigger="hover">
                                            <div class="currnet_face_info">
                                                <p>人脸表情识别占比（%）</p>
                                               
                                                <ul>
                                                    <li class="face_li_a"><span>平静：{{emotional[item.id].neutral}}%</span></li>
                                                    <li class="face_li_b"><span>高兴：{{emotional[item.id].happiness}}%</span></li>
                                                    <li class="face_li_c"><span :class="{active:Math.floor(emotional[item.id].anger)>=emotional[item.id].twinkle}">愤怒：{{emotional[item.id].anger}}%</span></li>
                                                    <li class="face_li_d"><span>恐惧：{{emotional[item.id].fear}}%</span></li>
                                                    <li class="face_li_e"><span :class="{active:Math.floor(emotional[item.id].sadness)>=emotional[item.id].twinkle}">悲伤：{{emotional[item.id].sadness}}%</span></li>
                                                    <li class="face_li_f"><span>厌恶：{{emotional[item.id].disgust}}%</span></li>
                                                    <li class="face_li_g"><span>惊奇：{{emotional[item.id].surprise}}%</span></li>
                                                </ul>
                                            </div>
                                            <div slot="reference" class="face_boxtop"><i :class="[{on:Math.floor(emotional[item.id].anger)>=emotional[item.id].twinkle||Math.floor(emotional[item.id].sadness)>=emotional[item.id].twinkle},emotional[item.id].maxEmotional]"></i></div>
                                        </el-popover>
                                    </div> -->
                                    <div v-if="!Boolean(requestingPushers[item.id] && requestingPushers[item.id].video)&&!Boolean(pusherVideosDisplay[item.id])" class="exitroom">{{item.name}} 视频被关闭</div>
                                    <video :id="'v_'+(item.id)" style=" margin-left: -50px; width:330px; height:190px;" autoplay playsinline></video>
                                </div>
                                <!-- 互动人员图片 end -->
                                <!-- 互动信息   要 start -->
                                <div class="meeting-member-foot">
                                    <!-- <i v-if="item.role=='APPLICANT'||item.role=='APPLICANT_AGENT'||item.role=='PETITION_AGENT'" class="icon_applicant"></i>
                                    <i v-else-if="item.role=='RESPONDENT'||item.role=='RESPONDENT_AGENT'" class="icon_respondent"></i>
                                    <i v-else-if="item.role=='MEDIATOR'" class="icon_meditor"></i> -->
                                    <span class="meeting-member-name">{{item.role == 'MEDIATOR'?item.rolename:(item.rolename+':'+item.name)}}</span>
                                </div>
                            </template>
                        </li>
                    </ul>
                </div>
                <div class="left_scroll" @click="memberListScroll(true)"></div>
            </div>
        </div>
        <div :class="[{insideopen: insideshow}, 'meeting-inside']">
            <div class="inside_button">
                <div v-if="!insideshow" class="inside_menu ico_btn_a" @click="openinside('first')">沟通记录</div>
                <!-- <div v-if="!insideshow" class="inside_menu ico_btn_b" @click="openinside('second')">会议材料</div> -->
                <div v-if="!insideshow" class="inside_menu ico_btn_c" @click="openinside('third')">工作区</div>
                <div v-if="insideshow" class="inside_menu_close" @click="openinside('first')">收起</div>
            </div>
            <inside v-show="insideshow" ref="inside" v-model="comdata" :meetingId="meetingId" :singleCaseId="singleCaseId" :wselement="ws" @comcallback="changStatushNotice" @sourceMessage="setSource" @getOrgid="getOrgid"></inside>
        </div>
        <privatechat ref="privatechat" v-model="comdata" :wselement="ws" :socketStatus="socketStatus" :members="member_list" @comcallback="changStatushMessage" @sourceMessage="setSource"></privatechat>
        <invite-assistance ref="assistance" :comdata="comdata" :orgId='orgId'></invite-assistance>
        <el-dialog
            title="受邀人邀请码查阅"
            :visible.sync="DialogCodeVisible"
            width="50%"
            center>
            <div class="invite-list">
                <div class="invite-title">
                    <div>角色</div>
                    <div>姓名</div>
                    <div>手机号</div>
                    <div>邀请码</div>
                    <div>身份证</div>
                    <div>提交姓名</div>
                </div>
                <div class="invite-con">
                    <div class="con" v-for="(item, index) in inviteList" :key="index">
                        <div>{{item.role}}</div>
                        <div>{{item.userName}}</div>
                        <div>{{item.mobilePhone}}</div>
                        <div>{{item.inviteCode}}</div>
                        <div>{{item.idCard}}</div>
                        <div>{{item.realName}}</div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="DialogCodeVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="温馨提示"
            :visible.sync="DialogVisible"
            width="30%"
            center>
            <div style="text-align: center;"><p>投屏模式下将单独开启新的视频窗口</p><br><p><el-checkbox v-model="checked">不再提示</el-checkbox></p></div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureThrowScreen">确 定</el-button>
            </span>
        </el-dialog>
        <bobao ref="Dialogbobao" :Bobaovideo1="Bobaovideo1" :Bobaovideo2="Bobaovideo2" :ws="ws" :comdata="comdata"></bobao>
    </div>
</template>
<script>
import axios from 'axios'
import inside from '../components/inside.vue'
import privatechat from '../components/privatechat.vue'
import inviteAssistance from '../components/inviteAssistances'
import bobao from '../components/bobao'
import {setStore,getStore,setStoreSession,removeStore} from '@/utils/utils.js'
import {getMediationInfo, getAllMeetingUserInviteCode} from '@/api/meeting'
import meetingMixins from '../assets/js/meetingMixins.js'
export default {
    mixins: [meetingMixins],
    components: {
        'inside':inside,
        'privatechat':privatechat,
        'inviteAssistance':inviteAssistance,
        'bobao': bobao
    },
    data(){
        return{
            meetingId:0,
            singleCaseId:0,
            DialogVisible: false,
            DialogCodeVisible: false,
            inviteList: [],
            isFaceOpen: false,
            faceSwitchStatus: false,
            emotional:{},
            orgId: '',
            listEmotional:{"anger":0.0,"disgust":0.0,"fear":0.0,"happiness":0.0,"neutral":0.0,"sadness":0.0,"surprise":0.0,"maxEmotional":'neutral',"twinkle":60},
            videosList:'',
        }
    },
    created() {
        if(this.$route.query.flk) {
            //第三方链接跳转调用
            this.getLogin()
        }

        this.singleCaseId = this.$route.query.caseId
        let query = this.$route.query, self = this;
        if(!query.token && !getStore('flk')){
            self.$alert('<h4 class="title_normal">温馨提示</h4><div>用户未登录</div>', '温馨提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                confirmButtonClass: 'meeting_button_primary_small',
                customClass: 'alert_quit'
            }).then(() => {
                document.location.href= './login'
            });
            return;
        }else{
            self.userID = query.memberId || JSON.parse(getStore('loginInfo')).userInfo.userId
            self.canDraw = true;
            self.selfName = query.memberName || JSON.parse(getStore('loginInfo')).userInfo.userName
            self.iswatcher = false
            self.ismediator = true
            self.istemporary = false    //有无权限操作
            self.ispusher = false       //判断是否推流
            self.invite = self.$route.query.invite
            self.roomID = self.$route.query.roomid
            self.caseID = self.$route.query.caseid
            self.meetingID = self.$route.query.meetingid
            self.comdata = {
                'caseID': self.$route.query.caseid,
                'roomID': self.$route.query.roomid,
                'meetingID': self.$route.query.meetingid,
                'userID': self.userID,
                'selfName': self.selfName,
                'iswatcher': false,
                'ispusher': false, //区分有无画面（有画面观摩人，无画面观摩人）
                'istemporary': false,
                'invite': self.$route.query.invite,
                'mediatorself': true,
                'roleType': null
            }
            self.userToken = self.$route.query.token || getStore('flk');
            self.meetingId = self.$route.query.meetingid
        }

        self.webRtcInit();

    },
    mounted(){
        
    },
    methods:{
        getLogin() {
            let loginInfo = {
                userInfo: {
                    personType: "STAFF",
                    userId: this.$route.query.userId,
                    loginName: null,
                    mobilePhone: "19900000000",
                    idCard: null,
                    userName: "仲裁员",
                    headPortraitUrl: null,
                    isRealName: false,
                    isFacialVerify: false,
                    email: null,
                    servicePersonStatus: "ONLINE",
                    sex: null,
                    petitionLetterAgentFlag: false,
                    roleType: null,
                    defaultPwdFla: false,
                    status: null
                },
                userRoles: [{
                    roleName: "仲裁员",
                    roleCode: "MEDIATOR",
                    roleType: "MEDIATOR",
                    organizationId: 1000036,
                    organizationName: "广州市仲裁委",
                    areaCode: null,
                    areaFullName: null,
                    remark: null,
                    platformCodes: null,
                    addressInfoDTO: null
                }],
                userMenuInfo: []
            }
            setStore('flk', this.$route.query.flk);
            setStoreSession('haslogin', 'yes');
            setStore('loginInfo', loginInfo);
        },
        countenanceSwitch () {
            let that = this
            this.isFaceOpen = !this.isFaceOpen
            this.faceSwitchStatus = !this.faceSwitchStatus
            // if(this.faceSwitchStatus&&!this.isPrivateRoom) {
            //     that.timing = setInterval(function(){that.ws.send(JSON.stringify({event:'LIST_NEWEST_EMOTIONAL'}))}, 2000);
            // }else {
            //     clearInterval(that.timing)
            // }
        },
        emotionalFun (data) {
            let memberFace,currentFace,that = this
            if(data.length){
                data.forEach((item)=>{
                    if(item["maxEmotional"]){
                        item["maxEmotional"] = item["maxEmotional"].toLowerCase()
                        that.$set(that.emotional,item.memberId,item)
                    }
                })
            }
        },
        videoChat(userId){
            videoPrivateChat({
                "meetingId": this.$route.query.meetingid,
                "meetingUserId":userId
            }).then((res)=>{
                if(res.data.code === 1000) {
                    this.videosList=res.data.data;
                    let msgdata={}
                    msgdata.event = "FORCE_VIDEO"
                    msgdata.data = {
                        receiverId:userId,
                        roomId:this.videosList.roomId,
                        meetingId:this.videosList.meetingId,
                        caseId:this.$route.query.caseid
                    }
                    this.ws.send(JSON.stringify(msgdata))
                    this.$router.push({
                        path:'/meetingChat',
                        query:{
                            roomId:this.videosList.roomId,
                            meetingid:this.videosList.meetingId,
                            caseid:this.$route.query.caseid,
                            isMediator:'true'
                        }
                    })
                }
            })
        },
        inviteCodeSearch() {
            //邀请码查询
            getAllMeetingUserInviteCode({
                id: this.$route.query.meetingid
            }).then((res)=>{
                if(res.data.code === 1000) {
                   this.inviteList = res.data.data
                }
            })
            this.DialogCodeVisible = true
        },
        handleBobaodialog() {
            this.$refs.Dialogbobao.DialogbobaoVisible = true
            this.ws.send(JSON.stringify({event:'OTHER', data: {event:'SEND_BOBAO_DIALOG',dialog: true}}))
        }       
    },

}
</script>
<style lang="scss">
    @import '../assets/css/meetingCss.scss';
</style>
